import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { ROUTES } from '@dealstack/frontend/investor/pages/Routing/routes';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { useQuery } from '@tanstack/react-query';
import { GetInvestorTransactionsRes } from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';

const getInvestorTransactions = async (investorId?: string) => {
	let endpoint: string = API_PATHS.SHAREHOLDER_INVESTOR_TRANSACTIONS_GET;

	if (investorId) {
		endpoint = `${endpoint}?investorId=${encodeURIComponent(investorId)}`;
	}
	return makeRequest<ApiV1.Response<GetInvestorTransactionsRes>>({
		endpoint,
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload);
};

export const useTransactionListsController = () => {
	const { investorId } = useParams();
	const navigate = useNavigate();

	const transactionsRequest = useQuery({
		queryKey: ['investorTransactions', investorId],
		queryFn: () => getInvestorTransactions(investorId),
	});

	useEffect(() => {
		void transactionsRequest.refetch();
	}, [investorId]);

	const navigateToDashboard = () => {
		const pathName = investorId
			? generatePath(ROUTES.VALUATIONS_AS_DASHBOARD, { investorId })
			: ROUTES.DASHBOARD;

		navigate(pathName);
	};

	return {
		transactionsRequest,
		navigateToDashboard,
	};
};
